var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreatmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#333333;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.2,23.2c2.4-6.5,8.6-11.2,16-11.2h56.4c7.4,0,13.6,4.7,16,11.2c0.1,0,0.1,0,0.2,0h12.5 c9.7,0,17.6,7.9,17.6,17.6V176c0,9.7-7.9,17.6-17.6,17.6H47.6c-9.7,0-17.6-7.9-17.6-17.6V40.8c0-9.7,7.9-17.6,17.6-17.6h12.5 C60.1,23.2,60.2,23.2,60.2,23.2z M76.2,23.2c-3.2,0-5.8,2.6-5.8,5.8s2.6,5.8,5.8,5.8h56.4c3.2,0,5.8-2.6,5.8-5.8s-2.6-5.8-5.8-5.8 C132.6,23.2,76.2,23.2,76.2,23.2z M60.1,34.4H47.6c-3.5,0-6.4,2.9-6.4,6.4V176c0,3.5,2.9,6.4,6.4,6.4h113.6c3.5,0,6.4-2.9,6.4-6.4 V40.8c0-3.5-2.9-6.4-6.4-6.4h-12.5c-2.3,6.7-8.6,11.6-16.1,11.6H76.2C68.7,46,62.3,41.1,60.1,34.4L60.1,34.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.4,77.2c3.1,0,5.6,2.5,5.6,5.6v14.4h14.4c3.1,0,5.6,2.5,5.6,5.6c0,3.1-2.5,5.6-5.6,5.6H110v14.4 c0,3.1-2.5,5.6-5.6,5.6c-3.1,0-5.6-2.5-5.6-5.6v-14.4H84.4c-3.1,0-5.6-2.5-5.6-5.6s2.5-5.6,5.6-5.6h14.4V82.8 C98.8,79.7,101.3,77.2,104.4,77.2L104.4,77.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreatmentIcon);
export default __webpack_public_path__ + "static/media/treatmentIcon.658c63e9.svg";
export { ForwardRef as ReactComponent };